@let preferences = galleryDisplayPreferences();
<div
  class="galleries"
  [class.compact]="preferences.appearance === 'compact'"
  [class.list]="preferences.appearance === 'list'"
  [class.centered]="center()"
>
  @let _galleries =
    externalSorting()
      ? galleries()
      : (galleries() | galleriesSortBy: false : preferences.sorting : preferences.pinFavourites);
  @for (gallery of _galleries; track gallery.id) {
    <div
      class="gallery"
      appDragItem
      [attr.id]="gallery.id"
      [id]="gallery.id"
      [type]="'gallery'"
      [context]="$any(gallery.folder)"
      [class.dragging]="dragging() === gallery.id"
      (dragging)="setDragging(gallery, $event)"
      (dropped)="dropped($event)"
    >
      @if (preferences.appearance === 'list') {
        <app-gallery-list-item
          [gallery]="$any(gallery)"
          [link]="linkGenerator()?.(gallery)"
          [target]="target()"
          [publicMode]="publicMode()"
          [dateMode]="dateMode()"
        ></app-gallery-list-item>
      } @else {
        @if (publicMode()) {
          <a [routerLink]="linkGenerator()?.(gallery)" [target]="target()" class="gallery-link" draggable="false">
            <app-gallery-item
              [gallery]="gallery"
              [galleryPermissions]="gallery.permissions"
              [publicMode]="publicMode()"
              [showPasswordProtected]="publicMode() ? 'full' : undefined"
              [compact]="preferences.appearance === 'compact'"
              [dateMode]="dateMode()"
            ></app-gallery-item>
          </a>
        } @else {
          <app-gallery-item-active
            [gallery]="$any(gallery)"
            [compact]="preferences.appearance === 'compact'"
            [dateMode]="dateMode()"
          ></app-gallery-item-active>
        }
      }
    </div>
  }
</div>
